import styled from "styled-components";

interface ToggleButtonProps {
  $active: boolean;
  $isLeft?: boolean;
  $isRight?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start; /* Optional: center align everything */
  gap: 8px; /* Spacing between text and toggle */

  ${({ theme }) => theme.breakpoints.md.query} {
    align-items: center;
  }
`;

export const LabelText = styled.span<{ $isCompare?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: #878787;

  span {
    font-weight: bold;
    color: ${({ $isCompare }) => ($isCompare ? "white" : "black")};
  }
`;

export const ToggleWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.default[200]};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.default[50]};
  padding: 4px;
`;

export const ToggleContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 5fr;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.base};
  border-radius: 4px;
  ${({ theme }) => theme.breakpoints.md.query} {
    width: 80vw;
    grid-template-columns: 1fr 1fr;
  }
`;

export const ToggleButton = styled.button<ToggleButtonProps>`
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  outline: none;
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors.primary.default : theme.colors.base};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.base : theme.colors.default.default};
  cursor: pointer;
  border-radius: ${({ $active }) => ($active ? "4px" : "none")};
`;
